import { builder } from 'common/js/configs/';
import { commonCreativeConfig } from '../common-creative-config';

export const formatConfigUnmarshaller = {
  creative: builder.holder({
    url: commonCreativeConfig.url,
    creativeRatio: commonCreativeConfig.creativeRatio,
    objectFit: builder.string('creative_object_fit', {
      possibleValues: [
        {
          name: 'Cover',
          value: 'cover'
        },
        {
          name: 'Contain',
          value: 'contain'
        }
      ],
      defaultValue: 'cover'
    })
  }),
  interaction: builder.string('interaction', {
    of: ['touch', 'click'],
    possibleValues: [
      {
        name: 'Touch',
        value: 'touch'
      },
      {
        name: 'Click',
        value: 'click'
      }
    ],
    defaultValue: 'click',
    d:''
  }),
  analyticsSsp: builder.holder({
    enable: builder.boolean('analytics_ssp_enable', {
      l:'',
      d:'',
      defaultValue: false
    })
  }),
  monitoringEnabled: builder.boolean('monitoring_enabled', {
    defaultValue: false
  })
};
